import { CompetitionTableRow } from '@cds/statistics/competition';
import { FixtureOutcome, FixtureResultStatistics, FixtureStatistics, Rank, ScoreStatistics, WonLostStatistics } from '@cds/statistics/fixture';

export interface Team {
    betRadarTeamId: number;
    name: string;
    nameTranslations: Translation[];
}

export interface Translation {
    languageId: string;
    value: string;
}

export interface TeamStatistics {
    betRadarTeamId?: number;
    rank: Rank;
    wonLostStatistics: WonLostStatistics;
    scoreStatistics?: ScoreStatistics;
}

export interface LastEvents {
    home: FixtureResultStatistics[];
    away: FixtureResultStatistics[];
}

export interface ScoreResult {
    scored: number;
    conceded: number;
    total?: number;
    ratio?: ScoreResult;
}

export interface StatisticsData {
    eventStats?: FixtureStatistics;
    leagueStats: CompetitionTableRow[];
}

export interface AvailableStatisticsData<T> {
    availableStats: T;
}

export interface RatioCount {
    ratio: number;
    count: number;
}

export enum StatisticsModelStatus {
    Success,
    NoConnection,
    NoStats,
}

export class StatisticsModel {
    headToHead?: StatisticsHeadToHead;
    lastMatches?: LastEvents;
    leagues?: CompetitionTableRow[];
    status: StatisticsModelStatus;
    selectedPage?: string;
    homeTeam?: TeamStatistics;
    awayTeam?: TeamStatistics;
    associationName?: string;
    averageScore?: AverageScore;

    constructor() {
        this.status = StatisticsModelStatus.NoStats;
    }

    get hasStats(): boolean {
        return this.status === StatisticsModelStatus.Success && (!!this.headToHead || !!this.lastMatches || !!this.leagues);
    }
}

export interface HeadToHeadSummary {
    team1: RatioCount;
    draw: RatioCount;
    team2: RatioCount;
}

export interface StatisticsHeadToHead {
    events: FixtureResultStatistics[];
    summary: HeadToHeadSummary;
}

export interface Participant {
    name: string;
    country?: string;
}

export interface StatisticsEventConstants {
    PAGE_SIZE: number;
    LEAGUE_TABLE: string;
    LAST_MATCHES: string;
    HEAD_TO_HEAD: string;
}

export interface Winpoints {
    player1: number;
    player2: number;
}

export interface TennisStatsPlayers {
    player1: any;
    player2: any;
}

export interface LiveStatisticsPeriod {
    name: string;
    enabled: boolean;
    indicate?: boolean;
}

export enum PreMatchStatisticsTabType {
    HeadToHead = 1,
    LeagueTable = 2,
    LastMatches = 3,
}

export enum TeamType {
    Home = 1,
    Away = 2,
}

export interface AverageScore {
    homeTeam: AverageScoreItem;
    awayTeam: AverageScoreItem;
}

export interface AverageScoreItem {
    home: ScoreResult;
    away: ScoreResult;
    total: ScoreResult;
}

export interface LastEventsStatistics {
    home: SlimFixtureResult[];
    away: SlimFixtureResult[];
}

export interface SlimFixtureResult {
    dateOfEvent?: string;
    fixtureOutcome: FixtureOutcome;
}
